<template>
  <div class="">
    <h3>Preparation:</h3>
    <div class="container pt-3 m-auto text-left ">
      <b-row>

        <b-col cols="2" class="mb-4 text-center" v-if="editar && permiso('BAB1EE7F')">
          <b-button variant="secondary" @click="nuevo" v-if="!preparation">Agregar</b-button>
          <b-button variant="warning" @click="edit" v-else>Editar</b-button>
        </b-col>
        

        <b-col cols="10" v-if="preparation && preparation.archivo_ruta">
          <b-button variant="outline-primary" @click="view()">
            {{ preparation.archivo_nombre }}
          </b-button>
          &nbsp;
          <b-button variant="outline-danger" @click="remove">Eliminar 
            <b-icon icon="x"></b-icon></b-button>

        </b-col>
        <b-col cols="10" v-else>
          <p>No se ha agregado un archivo de preparación</p>
        </b-col>
      </b-row>
      <b-row class="row">
        <b-col cols="12">
          <b-modal  no-close-on-backdrop no-close-on-esc title="Nuevo" ok-only v-model="show_nuevo"  id="modalNuevo" 
          hide-footer
          header-bg-variant="info" header-text-variant="white"><!-- @ok="" -->
            <template #modal-title>
              <h1 v-if="tema" class="text-center navbar-brand pt-0 pb-0 mb-0">{{ tema.nombre }} - Preparation Agregar </h1>
              <h1 v-else class="text-center navbar-brand pt-0 pb-0 mb-0">Preparation Agregar </h1>
            </template>
            <PreparationNuevo :tema_id="tema_id" @cerrar="show_nuevo = false" @actualizar="actualizar"></PreparationNuevo>
    
          </b-modal>
          
          <b-modal  no-close-on-backdrop no-close-on-esc title="Editar" ok-only v-model="show_editar"  id="modalEditar" 
          hide-footer
          header-bg-variant="info" header-text-variant="white"><!-- @ok="" -->
            <template #modal-title>
              <h1 v-if="tema" class="text-center navbar-brand pt-0 pb-0 mb-0">{{ tema.nombre }} - Preparation Editar </h1>
              <h1 v-else class="text-center navbar-brand pt-0 pb-0 mb-0">Preparation Editar </h1>
            </template>
            <PreparationEditar :preparation="preparation" @cerrar="show_editar = false" @actualizar="actualizar"></PreparationEditar>
    
          </b-modal>
    
          <b-modal  no-close-on-backdrop no-close-on-esc title="Eliminar" v-model="show_eliminar"  id="modalEliminar" 
          header-bg-variant="info" header-text-variant="white"><!-- @ok="" -->
            <template #modal-title>
              <h1 v-if="tema" class="text-center navbar-brand pt-0 pb-0 mb-0">{{ tema.nombre }} - Preparation Eliminar </h1>
              <h1 v-else class="text-center navbar-brand pt-0 pb-0 mb-0">Preparation Editar </h1>
            </template>
            <b-row>
              <b-col cols="12">
                <p v-if="preparation"> ¿Deseas eliminar este archivo: {{preparation.archivo_nombre}}?</p>
              </b-col>
            </b-row>
    
            <template #modal-footer="{ ok, cancel }">
              <b-button v-if="false" size="sm" variant="outline-danger" @click="ok()">
                Ok
              </b-button>
    
              <b-button size="sm" variant="outline-secondary" @click="show_eliminar = false">
                Cancelar
              </b-button>
              <!-- Button with custom close trigger value -->
              <b-button size="sm" variant="danger" @click="eliminar()">
                Eliminar
              </b-button>
            </template>
    
          </b-modal>
          <ViewPDF v-if="preparation && preparation.archivo_ruta && show_detalle" :url="preparation.archivo_ruta" :show_detail="show_detalle" @cerrar="show_detalle = false"></ViewPDF>
        </b-col>
      </b-row>
      
    </div>
  </div>
  
</template>


<script>
  import {mapState, mapActions, mapMutations, mapGetters} from 'vuex';
  import PreparationEditar from '@/components/Cursos/Temas/Preparation/Editar';
  import PreparationNuevo from '@/components/Cursos/Temas/Preparation/Nuevo';
  import ViewPDF from '@/components/Cursos/Temas/ViewPDF';
  
  
  export default {
    name: 'PreparationDetalle',
    components: {
      PreparationEditar,
      PreparationNuevo,
      ViewPDF
      
    },
    data () {
      return {
        preparation:null,
        show_nuevo: false,
        show_detalle: false,
        show_editar:false,
        show_eliminar:false
      }
    },
    props: {
      tema_id:String,
      editar:{
        type: Boolean,
        default: false
      }
    },
    mounted () {
     this.actualizar();
    },
    
    methods:{
        ...mapActions({
          fetchDetalle: 'temas_adicional/fetchDetalle',
          eliminarItem:'temas_adicional/eliminar',
          setWarning: 'setWarning',
        }),
      ...mapMutations({
        
      }),
      actualizar() {
        this.fetchDetalle({tema_id:this.tema_id, tipo:'preparation'}).then((result) => {
          this.preparation = result;
        }).catch((error) => {
          if (error.status === 404) {
            this.preparation = null;
          } else {
            console.log(error)
          }
        })
      },
      nuevo() {
        this.show_nuevo = true;
      },
      view() {
        console.log(this.show_detalle)
        if(this.show_detalle) {
          this.show_detalle = false;
        } else {
          this.show_detalle = true;
        }
      },
      edit() {
        this.show_editar = true;
      },
      remove(_item) {
        this.show_eliminar = true;
      },
      eliminar() {
        this.eliminarItem(this.preparation).then((result) => {
          console.log(result);
          this.setWarning("Eliminado correctamente",{root:true}).then(() => {
            this.actualizar()
          });
        }).finally(() => {
          this.show_eliminar = false;
        });
      },

    },
    computed:{
      ...mapState({
        detalle_tema: state => state.temas.detalle, 
        detalle: state => state.temas_adicional.detalle, 
        warning: state => state.warning
      }),
      ...mapGetters({
        permiso: 'auth/permiso', 
      }),
      tema() {
        if (this.detalle_tema[this.tema_id]) {
          return this.detalle_tema[this.tema_id];
        }
        return null;
      }
    }
    
  }
</script>

<style scope>

  .perfil_wrapper .container{
      background-color: #fff;
      padding: 15px;
  }
</style>
